import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import PrefDialog from "components/Global/Metric/PrefDialog";
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import DealAttachments from './DealAttachments'
import DealNotes from './DealNotes';
import AlertContainer from "components/TopNavigation/Alerts/AlertContainer";
import ReminderContainer from "components/TopNavigation/Reminders/ReminderContainer";

class DealTableOptionsMenu extends React.Component {
  state = {
    isPrefDialogOpen: false,
    isNotesOpen: false,
    isAttachmentsOpen:false,
    isModalOpen: false,
  };

  options = [
    { id: 1, value: "Edit Deal", onClick: optionId => { this.openDeal();} },
    { id: 2, isHR: true },
    { id: 3, value: "Notes", onClick: optionId => { this.openNotes(); } },
    { id: 4, value: "Attachments", onClick: optionId => { this.openAttachments(); } }
  ];

  openDeal = () => {        
    window.localStorage.setItem("shouldEditDeal", this.props.id);
      this.props.history.push(this.props.dealEditRedirect(this.props.id));
  };
  openNotes = () => {
    this.setState({ isNotesOpen: true });
  };

  closeNotes = () => {
    this.setState({ isNotesOpen: false });
  };

  openAttachments = () => {
    this.setState({ isAttachmentsOpen: true });
  };

  closeAttachments = () => {
    this.setState({ isAttachmentsOpen: false });
  };

  handlePrefDialogOpen = optionId => {
    this.setState({
      isPrefDialogOpen: optionId == 2
    });
  };

  handlePrefDialogClose = () => {
    this.setState({ isPrefDialogOpen: false });
    this.props.onClose();
  };  

  renderPrefDialog() {
    return (
      <PrefDialog
        isMetric={false}
        screenType={this.props.screenType}
        onClose={this.handlePrefDialogClose}
        isOpen={this.state.isPrefDialogOpen}
        prefData={this.props.metrics}
        maxHeight={900}
        maxCount={6}
      />
    );
  }

  openAlertModal = () => {
    this.setState({
      isAlertModalOpen: true
    })
  };

  closeAlertModal = () => {
    this.setState({
      isAlertModalOpen:false
    })
  };

  openReminderModal = () => {
    this.setState({
      isReminderModalOpen: true
    })
  };

  closeReminderModal = () => {
    this.setState({
      isReminderModalOpen: false
    })
  };

  render() {
    const { order, orderBy, columns } = this.props;
    const { id } = this.props;
    const { isAttachmentsOpen, isNotesOpen, options, isAlertModalOpen, isReminderModalOpen } = this.state;

    return (
      <React.Fragment>
        <AlertContainer
          isModalOpen={isAlertModalOpen}
          closeModal={this.closeAlertModal}
          showAlertIcon={false}
          showReminderIcon={false}
        />
        <ReminderContainer 
          isModalOpen={isReminderModalOpen}
          closeModal={this.closeReminderModal}
        />
        {this.renderPrefDialog()}
        <OptionsMenu options={this.options} maxHeight={900} />
        <DealAttachments
          dealId={id}
          isOpen={isAttachmentsOpen}
          openAttachments={this.openAttachments}
          closeAttachments={this.closeAttachments}
        />
        <DealNotes
          dealId={id}
          isOpen={isNotesOpen}
          openNotes={this.openNotes}
          closeNotes={this.closeNotes}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = () => {
  return {

  }
}
export default compose(
  connect(
    mapStateToProps,    
  ),
  withRouter
)(DealTableOptionsMenu);
